import React, { useState } from "react";
import { useGlobal } from "../context/ContenedorGlobal";
import API_URL from "../config";
import "../styles/Formularios.css";
import InputGenerico from "./InputGenerico";
import { useApiFetch } from "../utils/apiFetch";

function RegistrarConfig() {

    const { setModuloActual, setSubModuloActual, logout } = useGlobal();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [confi, setConfi] = useState("");
    const [verBoton, setVerBoton] = useState(true);
    const apiFetch = useApiFetch();
    const handleRegistrarConfi = async (e) => {

        setVerBoton(false);

        if (!confi) {
            setError("\u274C Ingrese el nombre de la nueva configuración")
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }

        try {

            const data = await apiFetch("registrar_configuracion.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ confi })
            }, logout);

            if (data.status === "ok") {
                setSuccess(`\u2705 Configuración registrada correctamente con el id ${data.id_confi}`);
                setTimeout(() => {
                    setModuloActual("Software");
                    setSubModuloActual(null);
                }, 3000);
            } else {
                setTimeout(() => {
                    setError("\u274C Error al registrar la configuración");
                    setModuloActual("Software");
                    setSubModuloActual(null);
                }, 3000);
            }
        } catch (err) {
            setTimeout(() => setError("\u274C Error de conexión con el servidor"), 3000);
        }
    };

    return (
        <div className="sesion-form">
            <>
                {error && <div className="error">{error}</div>}
                {success && <div className="success">{success}</div>}
            </>

            <form >
                <InputGenerico              //  Registrar el nombre de la nueva configuración
                    value={confi}
                    setValue={setConfi}
                    label="Ingrese el nombre de la configuración"
                    maxLength={50}
                    allowedChars="A-Z0-9._/\- "
                    transform="uppercase"
                    placeholder="Cambio de imagen a Windows 11"
                    title="Máximo 50 caracteres"
                />

                {verBoton && (
                    <div className="form-buttons">
                        <button type="button" onClick={handleRegistrarConfi}>
                            Registrar Configuración
                        </button>
                    </div>
                )}

            </form>

        </div>

    );

}

export default RegistrarConfig;